import { render, staticRenderFns } from "./EditUnit.vue?vue&type=template&id=80d6a6a6&scoped=true&"
import script from "./EditUnit.vue?vue&type=script&lang=js&"
export * from "./EditUnit.vue?vue&type=script&lang=js&"
import style0 from "./EditUnit.vue?vue&type=style&index=0&id=80d6a6a6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80d6a6a6",
  null
  
)

export default component.exports